import { useState } from "react";
import { createPortal } from "react-dom";
import ThreeDotsVerticalIcon from "../../../../../../../../assets/svg/three-dots-vertical-icon";
import { calculateRowActionMenuPosition } from "../utils/fileManagement.utils";
import type { RowActionsMenuProps } from "../types/fileManagement.types";

const RowActionsMenu = ({
  entity,
  menuItems,
  onRowAction,
}: RowActionsMenuProps) => {
  const [menuPosition, setMenuPosition] = useState<{
    x: number;
    y: number;
  } | null>(null);

  const isOpen = menuPosition !== null;

  const handleToggle = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    if (isOpen) {
      setMenuPosition(null);
      return;
    }
    const rect = e.currentTarget.getBoundingClientRect();
    setMenuPosition(calculateRowActionMenuPosition(rect, menuItems.length));
  };

  return (
    <>
      <div
        data-three-dots-button
        className="flex items-center justify-center p-1 rounded-md cursor-pointer hover:bg-hover-effect dark:hover:bg-hover-effect-dk transition-colors duration-200"
        onClick={handleToggle}
      >
        <ThreeDotsVerticalIcon className="w-[18px] h-[18px] text-gray-placeholder dark:text-gray-placeholder-dk" />
      </div>
      {isOpen &&
        createPortal(
          <>
            <div
              className="fixed inset-0 z-99"
              onClick={(e) => {
                e.stopPropagation();
                setMenuPosition(null);
              }}
            />
            <div
              className="fixed z-100 min-w-[180px] py-3 px-3 bg-popper-bg dark:bg-popper-bg-dk backdrop-blur-[20px] border border-border-gray dark:border-border-gray-dk rounded-[8px] shadow-popper-blur-effect flex flex-col"
              style={{ left: menuPosition?.x, top: menuPosition?.y }}
              data-popup-content
            >
              {menuItems?.map((item) => {
                const isDisabled = item?.disabled === true;
                const colorClass =
                  item?.action === "delete"
                    ? "text-verba-red-alert dark:text-verba-red-alert-dk"
                    : "text-heading-text dark:text-heading-text-dk";
                return (
                  <button
                    key={item?.action}
                    type="button"
                    disabled={isDisabled}
                    className={`px-2 py-2 rounded-lg text-left text-md font-normal transition-colors duration-200 ${
                      isDisabled
                        ? "text-gray-placeholder dark:text-gray-placeholder-dk cursor-not-allowed"
                        : `hover:bg-hover-effect dark:hover:bg-hover-effect-dk cursor-pointer ${colorClass}`
                    }`}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (isDisabled) return;
                      setMenuPosition(null);
                      onRowAction?.(entity, item?.action);
                    }}
                  >
                    {item?.label}
                  </button>
                );
              })}
            </div>
          </>,
          document.body
        )}
    </>
  );
};

export default RowActionsMenu;
